import textDriverFactory from '../Text/Text.puppeteer.driver';

export default textDriverFactory;
